export default {"src":"/_next/static/media/ico_excla2.d83b45e3.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};